import Controller from "./routeEdit.controller";
import template from "./routeEdit.html";

const routeEdit = {
  template,
  controller: Controller,
};

export default routeEdit;



// WEBPACK FOOTER //
// ./src/pages/routeEdit/routeEdit.component.js